export type IndicatorType = {
  label: string;
  value: string;
  model_name: string;
  type?: string;
};

export const INDICATOR_TYPE_WASH: string = 'WASH';
export const NO_IMPROVED_WATER_PREMISES_FIELD_VALUE_BACKUP: string = 'WS_SRCE_P_IMP';
export const NO_IMPROVED_WATER_PREMISES_FIELD_VALUE: string = 'WS_SRCE_P_IOP';

export const INDICATORS: IndicatorType[] = [
  // {
  //   label: 'Children stunted',
  //   value: 'CN_NUTS_C_HA2',
  //   model_name: 'stunted_test',
  // },
  // {
  //   label: 'Children with any anemia',
  //   value: 'CN_ANMC_C_ANY',
  //   model_name: 'any_anemia_ch',
  // },
  // {
  //   label: 'DPT 3 vaccination received',
  //   value: 'CH_VACS_C_DP3',
  //   model_name: 'vaccinedpt3_test',
  // },
  // {
  //   label: 'Received all 8 basic vaccinations',
  //   value: 'CH_VACS_C_BAS',
  //   model_name: 'vaccineall_test',
  // },
  // {
  //   label: 'Treatment of diarrhea: Continued feeding and ORT',
  //   value: 'CH_DIAT_C_CFO',
  //   model_name: 'ort_fdg_treat',
  // },
  // {
  //   label: 'Unmet need for family planning',
  //   value: 'FP_NADM_W_UNT',
  //   model_name: 'unmet_need',
  // },
  // {
  //   label: 'Place of delivery: Health facility',
  //   value: 'RH_DELP_C_DHF',
  //   model_name: 'hf_delivery',
  // },
  // {
  //   label: 'Antenatal visits for pregnancy: 4+ visits',
  //   value: 'RH_ANCN_W_N4P',
  //   model_name: 'anc_visit_test',
  // },
  // {
  //   label: 'Women with secondary or higher education',
  //   value: 'ED_EDUC_W_SEH',
  //   model_name: 'women_literate',
  // },
  // {
  //   label: 'Married women currently using any method of contraception',
  //   value: 'FP_CUSM_W_ANY',
  //   model_name: 'modern_cpr',
  // },
  // {
  //   label: 'Persons with access to an insecticide-treated mosquito net (ITN)',
  //   value: 'ML_ITNA_P_ACC',
  //   model_name: 'itn_test',
  // },
  {
    label: 'Population without basic water service',
    value: 'WS_SRCE_P_BAS',
    model_name: 'basic_water',
    type: INDICATOR_TYPE_WASH,
  },
  {
    label: 'Population using open defecation',
    value: 'WS_TLET_P_NFC',
    model_name: 'open_defecation',
    type: INDICATOR_TYPE_WASH,
  },
  {
    label: 'Population without basic sanitation service',
    value: 'WS_TLET_P_BAS',
    model_name: 'basic_sanitation',
    type: INDICATOR_TYPE_WASH,
  },
  // TODO: 2:42 PM - ok, we will fix it next time we make a change to the app: 'WS_SRCE_P_IMP' => 'WS_SRCE_P_IOP'
  // TODO: This is a temporary fix to handle the fact that the indicator value is not the same as the field name in the GIS REST API
  {
    label: 'Population without improved water source on the premises',
    value: NO_IMPROVED_WATER_PREMISES_FIELD_VALUE_BACKUP,
    model_name: 'no_improved_water_premises',
    type: INDICATOR_TYPE_WASH,
  },
  // {
  //   label: 'Physical or sexual or emotional violence committed by husband/partner in last 12 months',
  //   value: 'DV_SPV1_W_ANY',
  //   model_name: 'spousal_viol',
  // },
  // {
  //   label: 'Discriminatory attitudes towards people living with HIV',
  //   value: 'HA_DATT_W_DIS',
  //   model_name: 'hiv_discrimination',
  // },
  // {
  //   label: 'Children under 5 with fever in the last two weeks',
  //   value: 'ML_FEVR_C_FEV',
  //   model_name: 'fever_test',
  // },
  // {
  //   label: 'Children wasted',
  //   value: 'CN_NUTS_C_WH',
  //   model_name: 'wasted_tes',
  // },
];
